module.exports = __webpack_public_path__ + "img/sign-pending.fbfbe110.png";